// extracted by mini-css-extract-plugin
export default {"wrapper":"AllProductsWrapper_wrapper__B+gY2","gridContainer":"AllProductsWrapper_gridContainer__9VaO4"};